var _path, _rect, _path2, _path3, _path4, _rect2, _rect3, _path5, _path6, _path7, _rect4, _rect5, _circle, _rect6, _circle2, _rect7, _path8, _circle3, _circle4, _circle5, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 247,
    viewBox: "0 0 280 247",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.579 190.042C162.548 203.869 135.431 198.635 110.824 195.304C85.6444 191.895 62.1157 186.358 47.7674 171.116C29.1621 151.352 1.68972 127.469 20.467 99.3197C39.3383 71.0291 88.3911 76.0657 122.543 59.0173C156.941 41.8462 169.91 19.0883 202.234 24.8705C234.795 30.6953 231.156 50.9384 233.587 78.8816C235.081 96.0403 235.574 112.327 228.027 130.56C219.177 151.942 211.966 176.57 187.579 190.042Z",
    fill: "#D9EBFF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 208.45,
    y: 75.183,
    width: 8,
    height: 50.8486,
    rx: 4,
    transform: "rotate(46.2696 208.45 75.183)",
    fill: "white",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M198.21 197.5H124.361C120.969 197.5 118.066 195.069 117.47 191.731L102.47 107.731C101.704 103.44 105.002 99.5 109.361 99.5H207.21C211.371 99.5 214.613 103.108 214.17 107.246L205.17 191.246C204.789 194.803 201.787 197.5 198.21 197.5Z",
    fill: "white",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 199.5H230",
    stroke: "black",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 200H15",
    stroke: "black",
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 98.7069,
    y: 80.9638,
    width: 8,
    height: 50.8486,
    rx: 4,
    transform: "rotate(-46.27 98.7069 80.9638)",
    fill: "white",
    stroke: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 161.25,
    y: 126.509,
    width: 8,
    height: 46.1082,
    rx: 4,
    transform: "rotate(6 161.25 126.509)",
    stroke: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38 81.5H104.5",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M144 82H206",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M136.21 197.5H62.3607C58.9694 197.5 56.0659 195.069 55.4697 191.731L40.4697 107.731C39.7036 103.44 43.0023 99.5 47.3607 99.5H145.21C149.371 99.5 152.613 103.108 152.17 107.246L143.17 191.246C142.789 194.803 139.787 197.5 136.21 197.5Z",
    fill: "white",
    stroke: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 177.951,
    y: 126.509,
    width: 8,
    height: 46.1082,
    rx: 4,
    transform: "rotate(6 177.951 126.509)",
    stroke: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 193.951,
    y: 126.509,
    width: 8,
    height: 46.1082,
    rx: 4,
    transform: "rotate(6 193.951 126.509)",
    stroke: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 115,
    cy: 110,
    r: 7.5,
    stroke: "black"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 145.618,
    y: 75.183,
    width: 8,
    height: 50.8486,
    rx: 4,
    transform: "rotate(46.2696 145.618 75.183)",
    fill: "white",
    stroke: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 110,
    r: 7.5,
    stroke: "black"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 32.7069,
    y: 80.9638,
    width: 8,
    height: 50.8486,
    rx: 4,
    transform: "rotate(-46.27 32.7069 80.9638)",
    fill: "white",
    stroke: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5 143C85.5 131.5 103.5 130.5 103.5 143",
    stroke: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 133,
    r: 5,
    fill: "black"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 133,
    r: 5,
    fill: "black"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 129,
    cy: 40,
    r: 22.5,
    stroke: "black",
    strokeDasharray: "6 6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M133.713 39.584C133.713 40.4 133.513 41.16 133.113 41.864C132.729 42.568 132.193 43.128 131.505 43.544C130.833 43.944 130.097 44.144 129.297 44.144C128.497 44.144 127.753 43.944 127.065 43.544C126.393 43.128 125.857 42.568 125.457 41.864C125.073 41.16 124.881 40.4 124.881 39.584C124.881 38.768 125.073 38.008 125.457 37.304C125.857 36.6 126.393 36.04 127.065 35.624C127.753 35.208 128.497 35 129.297 35C130.097 35 130.833 35.208 131.505 35.624C132.193 36.04 132.729 36.6 133.113 37.304C133.513 38.008 133.713 38.768 133.713 39.584ZM127.353 39.584C127.353 40.08 127.545 40.504 127.929 40.856C128.313 41.208 128.769 41.384 129.297 41.384C129.825 41.384 130.281 41.208 130.665 40.856C131.049 40.504 131.241 40.08 131.241 39.584C131.241 39.088 131.049 38.664 130.665 38.312C130.281 37.96 129.825 37.784 129.297 37.784C128.769 37.784 128.313 37.96 127.929 38.312C127.545 38.664 127.353 39.088 127.353 39.584Z",
    fill: "#212429"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCart);
export default __webpack_public_path__ + "static/media/empty-cart.01ce57235032ea7a57a2c0094e294910.svg";
export { ForwardRef as ReactComponent };